import * as React from 'react';

const SvgIconNotAvailable = (props) => (
  <svg viewBox="0 0 25 2" fill="none" fillOpacity="0" width="24" xmlns="http://www.w3.org/2000/svg" data-icon="1" {...props}>
    <path d="M.5 1h24" stroke="#A5A5A5" strokeWidth={2} />
  </svg>
);

export default SvgIconNotAvailable;
